import { useState, useEffect, useCallback } from 'react';
import { authService } from '../services/authService';
import { leaveService } from '../services/leaveService';

export const useEmployeeNotifications = () => {
  const [rejectedLeavesCount, setRejectedLeavesCount] = useState<number>(0);
  const [rejectedTimesheetsCount, setRejectedTimesheetsCount] = useState<number>(0);
  const [draftTimesheetId, setDraftTimesheetId] = useState<number | null>(null);

  const fetchNotifications = useCallback(async () => {
    try {
      const token = authService.getAccessToken();
      const headers = {
        'Authorization': token ? `Bearer ${token}` : '',
        'Content-Type': 'application/json',
      };

    // 1. Récupération des feuilles de temps (Via route managée en premier pour les managers)
      try {
        let tsResponse = await fetch('/api/managed-department-timesheets/', { headers });
        
        // Si la route managée échoue ou renvoie 403, on essaie la globale, sinon on ignore
        if (!tsResponse.ok && tsResponse.status === 403) {
          tsResponse = await fetch('/api/timesheets/', { headers });
        }

        if (tsResponse.ok) {
          const data = await tsResponse.json();
          const list: any[] = data.results || data;
          
          const draft = list.find(t => {
            const status = String(t.status || '').toLowerCase();
            return status === 'draft' || status === 'brouillon';
          });

          const rejectedTs = list.filter(t => {
            const status = String(t.status || '').toLowerCase();
            return ['rejected', 'refuse', 'refusée'].includes(status);
          });
          
          setRejectedTimesheetsCount(rejectedTs.length);
          setDraftTimesheetId(draft ? draft.id : null);
        } else {
          setRejectedTimesheetsCount(0);
          setDraftTimesheetId(null);
        }
      } catch (tsErr) {
        setRejectedTimesheetsCount(0);
        setDraftTimesheetId(null);
      }

      // 2. Récupération des congés via leaveService (qui gère déjà le repli managé)
      try {
        const leavesData = await leaveService.getLeaveRequests();
        const leavesList: any[] = leavesData.results || leavesData;

        const rejectedLeaves = leavesList.filter(l => {
          const status = String(l.status || '').toLowerCase();
          return [
            'rejected', 'refuse', 'refusée'
          ].includes(status);
        });
        
        setRejectedLeavesCount(rejectedLeaves.length);
      } catch (leaveErr) {
        setRejectedLeavesCount(0);
      }

    } catch (err) {
      console.error("Erreur globale chargement notifications employé :", err);
    }
  }, []);

  useEffect(() => {
    fetchNotifications();

    window.addEventListener('timesheetStatusUpdated', fetchNotifications);
    window.addEventListener('leaveStatusUpdated', fetchNotifications);

    return () => {
      window.removeEventListener('timesheetStatusUpdated', fetchNotifications);
      window.removeEventListener('leaveStatusUpdated', fetchNotifications);
    };
  }, [fetchNotifications]);

  return {
    rejectedLeavesCount,
    rejectedTimesheetsCount,
    draftTimesheetId,
  };
};